import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Reports = lazy(() => import("@/pages/Reports"));

export const Route = createFileRoute("/rapporter/")({
  // Hela rapportlistan från databasen i server-HTML:en, så att även de
  // senaste rapporterna (som inte finns i de inbyggda) länkas från sidan.
  loader: async ({ context }) => {
    const [{ monthlyReportsQueryOptions }, { archiveLinksLoader }] = await Promise.all([
      import("@/hooks/useContent"),
      import("@/hooks/useScrapedPage"),
    ]);
    // Även de importerade äldre rapporterna (scraped_pages) länkas härifrån.
    const [reports, archive] = await Promise.all([
      context.queryClient.ensureQueryData(monthlyReportsQueryOptions()).catch(() => null),
      archiveLinksLoader(context.queryClient, "/rapporter"),
    ]);
    return { reports, archive };
  },
  head: () => seoHead("/rapporter"),
  component: ReportsRoute,
});

function ReportsRoute() {
  const { reports, archive } = Route.useLoaderData();
  return <Reports initialReports={reports} archive={archive} />;
}
